module.exports = __webpack_public_path__ + "static/media/lap.5ddb0187.svg";